import { render, staticRenderFns } from "./FeatFields.vue?vue&type=template&id=37b4d424"
import script from "./FeatFields.vue?vue&type=script&lang=js"
export * from "./FeatFields.vue?vue&type=script&lang=js"
import style0 from "./FeatFields.vue?vue&type=style&index=0&id=37b4d424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports